import { JSON_CONTENT_TYPE, TOKEN_NAME } from '../../constant/constants';
import { UserDto } from '../../dto/user/UserDto';
import { IApiParams } from '../../interface/IApiParams';
import { getApi } from '../getApi';

export const apiDeleteUser = async (dto: UserDto) => {
  const params: IApiParams = {
    url: '/license/deleteUserId.php',
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      Token: localStorage.getItem(TOKEN_NAME),
    },
  };
  return getApi(params, 'DELETE', dto);
};
